import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/Hero/Hero.css";

const FoundationHero = () => {
  const navigate = useNavigate();

  const handleDonate = () => {
    navigate("/donate");
  };

  const handlePartner = () => {
    // Navigate to partnerships section
    const partnershipsSection = document.getElementById("partnerships");
    if (partnershipsSection) {
      partnershipsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleGrant = () => {
    // Navigate to contact section
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="hero-section">
      <style jsx>{`
        .hero-section {
          min-height: 100vh;
          background-size: cover;
          background-position: center;
          background-attachment: fixed;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .hero-section::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: radial-gradient(
              circle at 20% 20%,
              rgba(0, 117, 154, 0.2) 0%,
              transparent 50%
            ),
            radial-gradient(
              circle at 80% 80%,
              rgba(46, 49, 60, 0.3) 0%,
              transparent 50%
            ),
            radial-gradient(
              circle at 50% 50%,
              rgba(255, 255, 255, 0.05) 0%,
              transparent 70%
            );
          pointer-events: none;
        }

        .hero-content {
          text-align: center;
          max-width: 1200px;
          padding: 2rem;
          position: relative;
          z-index: 2;
        }

        .hero-title {
          font-size: clamp(2.5rem, 6vw, 4.5rem);
          font-weight: 800;
          color: #ffffff;
          line-height: 1.1;
          margin-bottom: 2rem;
          letter-spacing: -0.02em;
          text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
          animation: fadeInUp 1s ease-out;
        }

        .hero-subtitle {
          font-size: clamp(1.1rem, 2.5vw, 1.4rem);
          color: rgba(255, 255, 255, 0.9);
          line-height: 1.6;
          margin-bottom: 3rem;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
          font-weight: 300;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
          animation: fadeInUp 1s ease-out 0.3s both;
        }

        .cta-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 1.5rem;
          justify-content: center;
          align-items: center;
          animation: fadeInUp 1s ease-out 0.6s both;
        }

        .cta-button {
          padding: 1rem 2.5rem;
          border-radius: 50px;
          font-size: 1rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          min-width: 200px;
          text-decoration: none;
          display: inline-block;
        }

        .cta-button::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.2),
            transparent
          );
          transition: left 0.5s ease;
        }

        .cta-button:hover::before {
          left: 100%;
        }

        .btn-primary {
          background: linear-gradient(135deg, #00759a, #006d8a);
          color: #ffffff;
          box-shadow: 0 8px 25px rgba(0, 117, 154, 0.3);
        }

        .btn-primary:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(0, 117, 154, 0.4);
          background: linear-gradient(135deg, #006d8a, #005f7a);
        }

        .btn-tertiary:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(46, 49, 60, 0.4);
          background: linear-gradient(135deg, #1f2937, #111827);
        }

        .floating-elements {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
          overflow: hidden;
        }

        .floating-element {
          position: absolute;
          width: 6px;
          height: 6px;
          background: rgba(255, 255, 255, 0.6);
          border-radius: 50%;
          animation: float 6s ease-in-out infinite;
        }

        .floating-element:nth-child(1) {
          top: 20%;
          left: 10%;
          animation-delay: 0s;
        }

        .floating-element:nth-child(2) {
          top: 60%;
          right: 15%;
          animation-delay: 2s;
        }

        .floating-element:nth-child(3) {
          bottom: 30%;
          left: 20%;
          animation-delay: 4s;
        }

        .floating-element:nth-child(4) {
          top: 40%;
          right: 30%;
          animation-delay: 1s;
        }

        .floating-element:nth-child(5) {
          bottom: 20%;
          right: 10%;
          animation-delay: 3s;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(0px) scale(1);
            opacity: 0.6;
          }
          50% {
            transform: translateY(-20px) scale(1.2);
            opacity: 1;
          }
        }

        @media (max-width: 768px) {
          .hero-content {
            padding: 1.5rem;
          }

          .cta-buttons {
            flex-direction: column;
            gap: 1rem;
          }

          .cta-button {
            width: 100%;
            max-width: 300px;
          }

          .hero-section {
            background-attachment: scroll;
          }
        }

        @media (max-width: 480px) {
          .hero-title {
            margin-bottom: 1.5rem;
          }

          .hero-subtitle {
            margin-bottom: 2rem;
          }
        }
      `}</style>

      <div className="floating-elements">
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
      </div>

      <div className="hero-content">
        <h1 className="hero-title">
          Empowering Communities
          <br />
          Through Education and
          <br />
          Collaboration
        </h1>

        <p className="hero-subtitle">
          Supporting education, community projects, and global growth
          initiatives
        </p>

        <div className="cta-buttons">
          <button
            className="cta-button btn-primary"
            onClick={handleGrant}
            aria-label="Apply for a grant - opens contact form"
          >
            Apply for a Grant
          </button>
          <button
            className="cta-button btn-primary"
            onClick={handleDonate}
            aria-label="Donate today - navigate to donation page"
          >
            Donate Today
          </button>
          <button
            className="cta-button btn-primary"
            onClick={handlePartner}
            aria-label="Partner with us - view partnership opportunities"
          >
            Partner with Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default FoundationHero;
